export var Language;
(function (Language) {
    Language["Dutch"] = "nl";
    Language["English"] = "en";
    Language["French"] = "fr";
})(Language || (Language = {}));
//# sourceMappingURL=Language.js.map